export const GET_PROJECT_HOMEPAGE = 'GET_PROJECT_HOMEPAGE';
export const GET_PROJECT_FILES = 'GET_PROJECT_FILES';
export const GET_PROJECT_FILES360 = 'GET_PROJECT_FILES360';
export const GET_PROJECT_HOUSE_CONFIGURATOR = 'GET_PROJECT_HOUSE_CONFIGURATOR'